import { render, staticRenderFns } from "./RootContent.vue?vue&type=template&id=2a780e7b&"
import script from "./RootContent.vue?vue&type=script&lang=ts&"
export * from "./RootContent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports